<template>
	<div class="mensagem">
		<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0"
			objectbg="#0d0c0d" opacity="50" name="circular"></loader>
		<div class="container-fluid">
			<ol class="breadcrumb-arrow">
				<li>
					<a href="/home"><i class="fa fa-home"></i></a>
					<a href="/mensagem">Mensagens</a>
				</li>
			</ol>
		</div>

		<div class="container-fluid mt-2">
			<div class="row">
				<div class="col-4">

					<div class="card card-primary card-outline direct-chat direct-chat-primary" style="height: calc(100vh - 150px)">
						<div class="card-header">
							<h3 class="card-title">Contatos</h3>
						</div>
						<div class="card-body d-flex flex-column p-2">
							<div class="direct-chat-messages flex-grow-1" style="height: 0; overflow-y: auto; padding-right: 5px;">

								<div v-for="(cnt, index) in listaContato" :key="cnt.idmensagemcontato">
									<div :class="posicaoLista === index ? 'listaContatoSelecionado' : 'listaContato'"
										@click="carregarConversa(cnt.destinatario && cnt.destinatario.idusuario == remetente ? cnt.remetente.idusuario : cnt.destinatario.idusuario, index); progress = true">
										<img class="direct-chat-img mr-2" :src="cnt.destinatario && cnt.destinatario.idusuario == remetente ? cnt.remetente.avatar : cnt.destinatario.avatar">
										<div class="contatoInfo">
											{{ cnt.destinatario && cnt.destinatario.idusuario == remetente ? cnt.remetente.nome : cnt.destinatario.nome }}
											<div>
												<el-tooltip :content="cnt.naoLidas + ` mensagens não lidas`" placement="top" v-if="cnt.naoLidas > 0">
													<span class="badge badge-pill badge-info mr-2">{{ cnt.naoLidas }}</span>
												</el-tooltip>
												<el-tooltip content="Apagar conversa" placement="top">
													<i class="fas fa-trash text-muted opcao" @click.stop="apagarConversa(cnt, index)"></i>
												</el-tooltip>
											</div>
										</div>
									</div>
								</div>

							</div>
							<div class="listaContato ml-2" style="border-top: 1px dashed #CCC"
								@click="modalAdicionarContato">
								<div class="mr-2">
									<div class="text-center bg-info divIconAdd">
										<i class="fas fa-user-plus text-center text-light"></i>
									</div>
								</div>
								<I>Adicionar Contato</I>
							</div>
						</div>
					</div>

				</div>
				<div class="col-8">

					<!-- CONTEUDO DO CHAT -->
					<div class="row">
						<div class="col">
							<!-- DIRECT CHAT PRIMARY -->
							<div class="card card-primary card-outline direct-chat direct-chat-primary" style="height: calc(100vh - 150px)">
								<div class="card-header">
									<h3 class="card-title">Mensagens</h3>
								</div>
								<div class="card-body backConversas d-flex flex-column p-0">
									<div class="direct-chat-messages flex-grow-1 p-3" id="conversa" style="height: 0; overflow-y: auto;">

										<!-- ÁREA DE MENSAGENS -->

										<div v-if="conversaVazia" class="mt-5">
											<div class="text-center">
												<i class="far fa-comment-dots mr-1"></i>
												<strong>Conversa ainda não iniciada!</strong>
											</div>
											<div class="text-center mt-4">
												Inicie a conversa enviando uma mensagem no campo abaixo
											</div>
										</div>

										<div v-for="msg in conversa" :key="msg.idmensagem">
											<!-- MENSAGEM DO CONTATO (RECEBIDA) -->
											<div class="d-flex mb-3" v-if="msg.destinatario.idusuario == remetente">
												<img class="direct-chat-img mr-2" :src="msg.remetente.avatar" alt="Avatar">
												<div class="msg-bubble received">
													<div class="msg-text">{{ msg.mensagem }}</div>
													<div class="msg-meta">
														{{ msg.tempoDataHora }}
													</div>
												</div>
											</div>

											<!-- MENSAGEM MINHA (ENVIADA) -->
											<div class="d-flex mb-3 justify-content-end" v-if="msg.remetente.idusuario == remetente">
												<div class="msg-bubble sent">
													<div class="msg-text">{{ msg.mensagem }}</div>
													<div class="msg-meta">
														{{ msg.tempoDataHora }}
														<el-tooltip v-if="msg.isVisual" content="Lida" placement="top">
															<i class="fas fa-check-double ml-1" style="color: #34b7f1;"></i>
														</el-tooltip>
														<el-tooltip v-else content="Enviada" placement="top">
															<i class="fas fa-check ml-1" style="color: #999;"></i>
														</el-tooltip>
													</div>
												</div>
												<img class="direct-chat-img ml-2" :src="msg.remetente.avatar" alt="Avatar">
											</div>
										</div>
									</div>
								</div>
								<div class="card-footer">
									<div class="input-group">
										<input ref="campoTexto" type="text" v-model="mensagem" :disabled="envioBloqueado"
											@keypress.enter="enviarMensagem" placeholder="Mensagem..." class="form-control">
										<span class="input-group-append">
											<el-tooltip content="Enviar mensagem (Enter)" placement="top">
												<button class="btn btn-primary" @click="enviarMensagem"
													:disabled="envioBloqueado"> Enviar</button>
											</el-tooltip>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<modal :show.sync="modals.modalAddContato">
			<form class="ml-3 mt-3 mr-3 mb-3">
				<h4 class="text-center">Adicionar Contato</h4>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-search"></i></span>
					</div>
					<input type="text" class="form-control mb-2" v-model="addContatoNome"
						placeholder="Pesquisar contato por nome" @keyup="pesquisarNomeUsuario()" />
				</div>
				<div style="height: 300px; border: 1px dashed #C0C0C0; overflow: auto;">

					<div class="listaContato" v-for="cnto in listaAddContato" :key="cnto.idusuario">
						<img class="direct-chat-img mr-1" :src="cnto.avatar">
						<div class="contatoInfo" @click="adicionarContato(cnto.idusuario)">
							{{ cnto.nome }}
							<i class="fas fa-user-plus text-muted opcao mr-3"></i>
						</div>
					</div>

				</div>

				<br class="clear" />
				<div class="col-md-12 text-center mt-3">
					<button type="button" class="btn btn-danger ml-4" @click="fecharModal">
						Desistir
					</button>
				</div>
			</form>
		</modal>

	</div>
</template>

<script>
export default {
	props: ['rem', 'dest'],
	components: {
	},
	created() {
		this.carregarListaContato();
	},
	data() {
		return {
			conversa: [],
			mensagem: "",
			progress: true,
			posicaoLista: 0,
			idSelecionado: null,
			remetente: Number(localStorage.getItem("idusuario")),
			destinatario: null,
			envioBloqueado: false,
			conversaVazia: false,
			controleAtualizacao: false,
			addContatoNome: "",
			listaAddContato: [],
			listaContato: [],
			timeoutMsg: null,
			modals: {
				modalAddContato: false,
			},
		};
	},
	beforeDestroy() {
		if (this.timeoutMsg) clearTimeout(this.timeoutMsg);
	},
	methods: {
		carregarConversa(iddestinatario, index) {
			if (this.timeoutMsg) clearTimeout(this.timeoutMsg);
			if (this.listaContato.length > 0) {
				this.envioBloqueado = false;
			}
			if (index !== null && index !== undefined) {
				this.posicaoLista = index;
			}
			this.conversaVazia = false;
			
			if (iddestinatario == undefined) {
				if (this.rem != null && this.dest != null) {
					this.remetente = Number(this.rem);
					iddestinatario = Number(this.dest);
				} else {
					try {
						if (this.listaContato[0].destinatario.idusuario == this.remetente) {
							iddestinatario = this.listaContato[0].remetente.idusuario;
						} else {
							iddestinatario = this.listaContato[0].destinatario.idusuario;
						}
					} catch (error) {
						this.progress = false;
						this.envioBloqueado = true;
						return;
					}
				}
			}
			this.controleAtualizacao = false;
			this.destinatario = iddestinatario;
			
			let mensagem = { remetente: { idusuario: this.remetente }, destinatario: { idusuario: iddestinatario } };
			this.$clubApi.post('/mensagem/conversa', mensagem).then(response => {
				this.conversa = response.data.object;
				if (this.conversa.length === 0) {
					this.conversaVazia = true;
				}
				if (index === undefined && this.listaContato.length > 0) {
					this.posicaoLista = 0;
				}
				this.progress = false;
			})
			.catch(error => {
				this.$toastr.error(error.response && error.response.data ? error.response.data.msg : "Erro ao carregar mensagens");
			})
			.finally(() => {
				this.timeoutMsg = setTimeout(() => this.verificaNovaMsg(this.conversa.length), 3000);
				this.scrollToEnd();
			});
		},
		scrollToEnd() {
			this.$nextTick(() => {
				var container = this.$el.querySelector("#conversa");
				if (container) container.scrollTop = container.scrollHeight;
			});
		},
		verificaNovaMsg(tamConversa) {
			if (this.controleAtualizacao) return;
			if (this.timeoutMsg) clearTimeout(this.timeoutMsg);
			
			let mensagem = { remetente: { idusuario: this.remetente }, destinatario: { idusuario: this.destinatario } };
			this.$clubApi.post('/mensagem/conversa/tamanho', mensagem).then(response => {
				let tamanhoAtual = response.data.object;
				if (tamanhoAtual !== tamConversa) {
					this.$clubApi.post('/mensagem/conversa', mensagem).then(response => {
						this.conversa = response.data.object;
						this.scrollToEnd();
						this.timeoutMsg = setTimeout(() => this.verificaNovaMsg(this.conversa.length), 3000);
					});
				} else {
					this.timeoutMsg = setTimeout(() => this.verificaNovaMsg(tamConversa), 3000);
				}
			}).catch(() => {
				this.timeoutMsg = setTimeout(() => this.verificaNovaMsg(tamConversa), 5000);
			});
		},
		carregarListaContato() {
			this.$clubApi.get('/mensagem/contatos').then(response => {
				this.listaContato = response.data.object;
				if (this.$refs.campoTexto) this.$refs.campoTexto.focus();
			})
			.finally(() => {
				this.carregarConversa(this.idSelecionado, this.posicaoLista);
			});
		},
		apagarConversa(contato, index) {
			const options = { title: 'Confirmação', okLabel: 'Apagar', cancelLabel: 'Não' };
			this.$dialogs.confirm('Deseja remover a conversa? ', options).then(res => {
				if (res.ok) {
					this.$clubApi.delete('/mensagem/contato/' + contato.idmensagemcontato).then(response => {
						this.listaContato.splice(index, 1);
						this.controleAtualizacao = true;
						this.conversa = [];
						this.destinatario = null;
						this.envioBloqueado = true;
						if (this.timeoutMsg) clearTimeout(this.timeoutMsg);
						this.$toastr.success('Contato apagado com sucesso!');
						
						if (this.listaContato.length > 0) {
							this.carregarConversa(null, 0);
						} else {
							this.conversaVazia = true;
						}
					})
					.catch(error => {
						this.$toastr.error(error.response && error.response.data ? error.response.data.msg : "Erro ao apagar");
					});
				}
			});
		},
		modalAdicionarContato() {
			this.modals.modalAddContato = true;
		},
		fecharModal() {
			this.addContatoNome = "";
			this.listaAddContato = [];
			this.modals.modalAddContato = false;
		},
		pesquisarNomeUsuario() {
			if (this.addContatoNome === "") {
				this.listaAddContato = [];
			} else {
				this.$clubApi.get('/userchat/nome/' + this.addContatoNome).then(response => {
					this.listaAddContato = response.data.object;
				})
				.catch(error => {
					this.$toastr.error(error.response && error.response.data ? error.response.data.msg : "Erro na pesquisa");
				});
			}
		},
		adicionarContato(idusuario) {
			let podeAdd = true;
			if (idusuario == this.remetente) {
				this.$toastr.warning("Não pode adicionar você mesmo.");
				return;
			}
			for (let i = 0; i < this.listaContato.length; i++) {
				const contato = this.listaContato[i];
				if (contato.destinatario.idusuario == idusuario || contato.remetente.idusuario == idusuario) {
					podeAdd = false;
					break;
				}
			}
			if (podeAdd) {
				let mensagem = { remetente: { idusuario: this.remetente }, destinatario: { idusuario: idusuario } };
				this.$clubApi.post('/mensagem/contato', mensagem).then(response => {
					this.listaContato = response.data.object;
					this.$toastr.success('Contato adicionado com sucesso!');
					this.modals.modalAddContato = false;
					this.carregarListaContato();
				})
				.catch(error => {
					this.$toastr.error(error.response && error.response.data ? error.response.data.msg : "Erro ao adicionar");
				});
			} else {
				this.$toastr.warning("Contato já adicionado anteriormente.");
			}
		},
		enviarMensagem() {
			if (!this.mensagem || this.mensagem.trim() === '') return;
			this.envioBloqueado = true;
			this.progress = true;
			let mensagem = {
				mensagem: this.mensagem,
				remetente: { idusuario: this.remetente },
				destinatario: { idusuario: this.destinatario }
			};
			this.idSelecionado = this.destinatario;
			this.$clubApi.post('/mensagem', mensagem).then(response => {
				this.conversa = response.data.object;
				this.mensagem = "";
				this.envioBloqueado = false;
				this.$nextTick(() => { if (this.$refs.campoTexto) this.$refs.campoTexto.focus(); });
				this.posicaoLista = 0;
				this.carregarListaContato();
			})
			.catch(error => {
				this.envioBloqueado = false;
				this.$toastr.error(error.response && error.response.data ? error.response.data.msg : "Erro ao enviar");
			})
			.finally(() => {
				this.scrollToEnd();
				this.progress = false;
			});
		}
	}
};
</script>

<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.listaContato {
	align-items: center;
	display: flex;
	margin-bottom: 5px;
	padding: 8px 10px;
	border-radius: 8px;
	transition: background-color 0.2s;
	height: auto;
}

.listaContatoSelecionado {
	align-items: center;
	display: flex;
	margin-bottom: 5px;
	padding: 8px 10px;
	background: #e9ecef;
	border-radius: 8px;
	height: auto;
}

.listaContato:hover {
	background-color: #f8f9fa;
	cursor: pointer;
}

.listaContatoSelecionado:hover .opcao, .listaContato:hover .opcao {
	visibility: visible;
	opacity: 1;
}

.divIconAdd {
	height: 40px;
	width: 40px;
	border-radius: 50%;
	align-items: center;
	display: flex;
	justify-content: center;
}

.contatoInfo {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
}

.backConversas {
	background-color: #efeae2;
	background-image: url('https://web.whatsapp.com/img/bg-chat-tile-dark_a4be512e7195b6b733d9110b408f075d.png');
	background-blend-mode: overlay;
	background-size: initial;
	background-attachment: fixed;
}

.opcao {
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.3s linear;
	cursor: pointer;
}

.direct-chat-img {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	object-fit: cover;
}

/* Chat Bubbles */
.msg-bubble {
	max-width: 75%;
	padding: 8px 12px;
	border-radius: 8px;
	position: relative;
	box-shadow: 0 1px 1px rgba(0,0,0,0.1);
	font-size: 14px;
	line-height: 1.4;
	display: flex;
	flex-direction: column;
}

.msg-bubble.sent {
	background-color: #dcf8c6;
	border-top-right-radius: 0;
	color: #303030;
}

.msg-bubble.received {
	background-color: #ffffff;
	border-top-left-radius: 0;
	color: #303030;
}

.msg-text {
	word-wrap: break-word;
	white-space: pre-wrap;
}

.msg-meta {
	font-size: 11px;
	color: rgba(0,0,0,0.45);
	margin-top: 4px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.card-primary.card-outline {
	border-top: 3px solid #0db9d3;
}
</style>

